import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";

export class BarcodeFormat {
  public title: string;
  public width: number;
  public height: number;
  public multiple_per_page: string;
  public page_top_bottom_margin: number;
  public page_left_right_margin: number;
}

@Injectable()
export class ResourceService {
  httpHeaders = new HttpHeaders({ "Content-Type": "application/json" });
  catalogsUrl = "api/v2/catalogs";

  constructor(private httpClient: HttpClient) {}

  getBarcodeFormats(): Promise<BarcodeFormat[]> {
    return this.httpClient
      .get(
        "https://s3.amazonaws.com/nowinstore.com/resources/barcode-formats.json"
      )
      .toPromise()
      .then((res) => res as BarcodeFormat)
      .catch(this.handleError);
  }

  handleError(error: any): Promise<any> {
    console.error("An error occurred", error);
    return Promise.reject(error.message || error);
  }
}
